import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { useRouteActions } from 'app/agriculture/router/useRouteActions';
import { useTask } from 'app/agriculture/queries/tasks/useTask';
import { LinkedEntityList } from 'app/agriculture/components/LinkedEntityList/LinkedEntityList';
import { LinkIcon } from 'app/agriculture/icons';
import { useUsers } from 'app/agriculture/hooks/users/useUsers';
import { Button } from 'app/agriculture/components/Button/Button';

interface TaskStatsProps {
    taskId: string;
    showEditAction?: boolean;
    showCategory?: boolean;
}

export function TaskStats({
    taskId,
    showEditAction = false,
    showCategory = false,
}: TaskStatsProps) {
    const routeActions = useRouteActions();
    const { id, parentIds, category, assignees, creatorId, startDate, endDate } = useTask({
        taskId,
    });
    const allowedUsers = useUsers();
    const assignedUsers = assignees.map((userId) => {
        const user = allowedUsers.find((x) => x.id === userId);
        return user ? user.name : 'Unknown';
    });

    const creator = allowedUsers.find((user) => user.id === creatorId);

    return (
        <div className="TaskStats" data-testid="TaskStats">
            <SimpleGrid columns={3}>
                <StatDisplay
                    name="Attached to"
                    emptyStateMessage="N/A"
                    value={
                        parentIds.length === 0 ? null : (
                            <LinkedEntityList entityIds={parentIds} icon={<LinkIcon />} />
                        )
                    }
                />
                {!showCategory ? null : (
                    <StatDisplay name="Category" id="task-category" value={category} />
                )}
                {assignees.length === 0 ? null : (
                    <StatDisplay
                        name="Assigned to"
                        id="task-assigned-to"
                        value={assignedUsers.join(', ')}
                    />
                )}
                <StatDisplay
                    name="Start date"
                    id="task-start-date"
                    value={startDate.toLocaleDateString('en-AU')}
                />
                <StatDisplay
                    name="End date"
                    id="task-end-date"
                    value={endDate.toLocaleDateString('en-AU')}
                />
                <StatDisplay
                    name="Created by"
                    id="task-created-by"
                    value={creator?.name ?? 'Unknown'}
                />
                {!showEditAction ? null : (
                    <Button
                        text="Edit"
                        startIcon="edit"
                        variant="compact"
                        onClick={() => {
                            routeActions.edit(id, { type: 'Task' });
                        }}
                    />
                )}
            </SimpleGrid>
        </div>
    );
}
